module.exports = (__webpack_require__(0))(19);


//////////////////
// WEBPACK FOOTER
// delegated ./src/utilities/PluginUtils.js from dll-reference girder_plugin_large_image
// module id = 4
// module chunks = 0